module.exports = __webpack_public_path__ + "img/MG_4613R-scaled.2ce3303b.jpg";